module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('a', {
    staticClass: "link on",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("首页")]), _vm._v(" "), _c('a', {
    staticClass: "link",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.enterUser
    }
  }, [_vm._v("我")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6d01bcdc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer.vue
// module id = 49
// module chunks = 0